import React from 'react';
import {Modal} from '../../../../components';
import {QrCode} from '../../../Auths/QRCode';

function ScanQRCodeModal({open, setOpen, setOTPOpen, isLoading, _2FAData}) {
  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Setup 2FA - Scan QR code"
    >
      <QrCode
        isLoading={isLoading}
        _2FAData={_2FAData}
        setOTPOpen={setOTPOpen}
      />
    </Modal>
  );
}

export {ScanQRCodeModal};
